
import { memo } from "react";

function BlogHero() {
  return (
    <div className="relative h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/f8614fcd10107b42b073f1f73c905b7a.jpg"
          alt="Beautiful Black woman in modern kitchen"
          className="w-full h-full object-cover object-top"
          loading="eager"
          decoding="async"
          fetchPriority="high"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      </div>
      <div className="relative z-10 text-center px-4">
        <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold text-white drop-shadow-lg">
          Davis County Disaster Cleanup Blog
        </h1>
      </div>
    </div>
  );
}

export default memo(BlogHero);
